(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["custom-header-2"] && !window.DesignMode) return;
  try {
    
  var headerTop = $('.barra').outerHeight() + $('header').outerHeight();
  $('.cheader').css('max-height', 'calc(100vh - ' + headerTop + 'px)');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header-3"] && !window.DesignMode) return;
  try {
    
  var headerTop = $('.barra').outerHeight() + $('header').outerHeight();
  $('.cheader').css('max-height', 'calc(100vh - ' + headerTop + 'px)');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header-4"] && !window.DesignMode) return;
  try {
    
  var headerTop = $('.barra').outerHeight() + $('header').outerHeight();
  $('.cheader').css('max-height', 'calc(100vh - ' + headerTop + 'px)');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !window.DesignMode) return;
  try {
    
  var headerTop = $('.barra').outerHeight() + $('header').outerHeight();
  $('.cheader').css('max-height', 'calc(100vh - ' + headerTop + 'px)');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-state"]) return;
  try {
    
  // iFrameResize({log: true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section"]) return;
  try {
    
  $('<div class="quantity-nav"><div class="quantity-button quantity-up"><span>+</span></div><div class="quantity-button quantity-down"><span>-</span></div></div>').insertAfter('.sec-cantidad input');
  $('.sec-cantidad').each(function() {
    var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max') ? input.attr('max') : 1000;
    btnUp.click(function() {
      var newVal = parseFloat(input.val());
      if (newVal < max) {
        newVal++;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });
    btnDown.click(function() {
      var newVal = parseFloat(input.val());
      if (newVal > min) {
        newVal--;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shopthelook"]) return;
  try {
    
  jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.sec-cantidad input');
  jQuery('.sec-cantidad').each(function() {
    var spinner = jQuery(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
    btnUp.click(function() {
      var oldValue = parseFloat(input.val());
      if (oldValue >= max) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue + 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });
    btnDown.click(function() {
      var oldValue = parseFloat(input.val());
      if (oldValue <= min) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue - 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });
  });

  } catch(e) { console.error(e); }
})();

})();
